export default {
  Undetermined: 'Undetermined',
  NotLate: 'NotLate',
  LateContractual: 'LateContractual',
  LatePlanning: 'LatePlanning',
};
